import { render } from "./CardOwnerOverview.vue?vue&type=template&id=385a0d23&scoped=true"
import script from "./CardOwnerOverview.vue?vue&type=script&lang=js"
export * from "./CardOwnerOverview.vue?vue&type=script&lang=js"

import "./CardOwnerOverview.vue?vue&type=style&index=0&id=385a0d23&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385a0d23"]])

export default __exports__